import {neverland as $, html, useState} from 'neverland';
import { confirmPassword, forgotPassword } from '../lib/cognito.js';
import { PasswordChecklist, passwordMeetsAllRules } from '../lib/passwordRules.js';

const ResetPasswordPage = $(function(auth, setAuth, theme) {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pw, setPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');

  function getLogo() {
    if (theme && theme.logo && theme.logo !== '') {
      return '/static/img/logos-large/' + theme.logo;
    }
    return '/static/img/transparent-placeholder.png';
  }

  async function handleSubmit() {
    setError('');
    setLoading(true);

    const code = document.querySelector('#reset-code').value.trim();
    const pw1 = document.querySelector('#reset-password').value;
    const pw2 = document.querySelector('#reset-confirm-password').value;

    if (!code) {
      setError('Please enter the verification code.');
      setLoading(false);
      return;
    }

    if (!passwordMeetsAllRules(pw1)) {
      setError('Password does not meet all the requirements shown below.');
      setLoading(false);
      return;
    }

    if (pw1 !== pw2) {
      setError('Passwords do not match.');
      setLoading(false);
      return;
    }

    try {
      await confirmPassword(auth.resetEmail, code, pw1);
      setSuccess(true);
    } catch (err) {
      if (err.code === 'CodeMismatchException') {
        setError('Invalid code. Please check and try again.');
      } else if (err.code === 'ExpiredCodeException') {
        setError('Code has expired. Please request a new one.');
      } else if (err.code === 'InvalidPasswordException') {
        setError('Password does not meet requirements. Use at least 8 characters with uppercase, lowercase, numbers, and a special character.');
      } else {
        setError(`Failed to reset password: ${err.message || 'Unknown error'}`);
      }
    }

    setLoading(false);
  }

  async function handleResend() {
    setError('');
    try {
      await forgotPassword(auth.resetEmail);
      setError('');
      // Show a brief success indication via the warning-style message
      document.querySelector('#resend-msg').textContent = 'A new code has been sent to your email.';
    } catch (err) {
      setError(`Failed to resend code: ${err.message || 'Unknown error'}`);
    }
  }

  function handleKeyPress(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleSubmit();
    }
  }

  function goToLogin() {
    setAuth(prev => ({ ...prev, mfaPage: null, resetEmail: null }));
  }

  return html`
    <div class="centre-box login">
      <img src="${getLogo()}" class="squiggle logo-large" />

      <div id="login">
        ${success ? html`
          <h2 style="margin-bottom: 10px; font-size: 1.2em;">Password Reset</h2>
          <p style="margin-bottom: 12px; font-size: 1em; opacity: 0.8;">
            Your password has been reset successfully. You can now log in with your new password.
          </p>

          <button id="login-submit" onclick=${goToLogin}>
            <i class="fal fa-sign-in-alt"></i>&ensp;BACK TO LOGIN
          </button>
        ` : html`
          <h2 style="margin-bottom: 10px; font-size: 1.2em;">Reset Password</h2>
          <p style="margin-bottom: 12px; font-size: 1em; opacity: 0.8;">
            Enter the code sent to <strong>${auth.resetEmail}</strong> and choose a new password.
          </p>

          <span class="loginlabel">VERIFICATION CODE</span>
          <input type="text" id="reset-code" class="login-field" placeholder="Enter 6-digit code" /><br />

          <span class="loginlabel">NEW PASSWORD</span>
          <input type="password" id="reset-password" class="login-field" placeholder="Choose a new password" oninput=${(e) => setPw(e.target.value)} /><br />

          ${PasswordChecklist(pw, confirmPw)}

          <span class="loginlabel">CONFIRM PASSWORD</span>
          <input type="password" id="reset-confirm-password" class="login-field" placeholder="Confirm new password" oninput=${(e) => setConfirmPw(e.target.value)} onkeyup=${handleKeyPress} /><br />

          <button id="login-submit" onclick=${handleSubmit} disabled=${loading || !passwordMeetsAllRules(pw) || pw !== confirmPw}>
            ${loading ? 'Resetting...' : html`<i class="fal fa-key"></i>&ensp;RESET PASSWORD`}
          </button>

          <button class="back-link" onclick=${handleResend}>
            Didn't receive a code? Resend
          </button>
          <span id="resend-msg" style="display:block;font-size:0.95em;margin-top:4px;color:#28a745;text-align:center;"></span>

          <button class="back-link" onclick=${goToLogin}>
            &larr; Back to Login
          </button>
        `}

        ${error ? html`<div class="error"><strong>ERROR</strong><p>${error}</p></div>` : ''}
      </div>
    </div>
  `;
});

export default ResetPasswordPage;
